import React from "react";
import PropTypes from "prop-types";
import { DateRangePicker } from "react-bootstrap-daterangepicker";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";

const CustomDateRangePicker = ({
  isTextField,
  childClasses,
  datePickerName,
  datePickerValue,
  placeHolderText,
  handleDateChangeEvent,
  handleCancel,
  initialSettings,
}) => {
  return (
    <DateRangePicker
      onApply={handleDateChangeEvent}
      onCancel={handleCancel}
      initialSettings={initialSettings}
    >
      <input
        type="text"
        name={datePickerName}
        placeholder={`${placeHolderText || "Select Dates(s)"}`}
        className={
          isTextField
            ? "MuiOutlinedInput-root MuiOutlinedInput-input MuiOutlinedInput-notchedOutline"
            : childClasses.dateSearchBoxOpen
        }
        value={datePickerValue}
      />
    </DateRangePicker>
  );
};

CustomDateRangePicker.propTypes = {
  isTextField: PropTypes.bool,
  childClasses: PropTypes.object,
  datePickerName: PropTypes.string,
  datePickerValue: PropTypes.string,
  placeHolderText: PropTypes.string,
  handleDateChangeEvent: PropTypes.func,
  handleCancel: PropTypes.func,
  initialSettings: PropTypes.object,
};

export default React.memo(CustomDateRangePicker);
